import { useMutation } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';
import { queryClient } from 'api/queryClient';

export function useDeletePostReaction() {
  const { mutate: deletePostReaction, isLoading } = useMutation(API_HANDLERS.REACTIONS.DELETE, {
    onSuccess: () => {
      queryClient.invalidateQueries(['posts']);
      queryClient.invalidateQueries(['post-details']);
      queryClient.invalidateQueries(['reactions']);
    },
  });

  return { deletePostReaction, isLoading };
}
